export default __webpack_public_path__ + "static/dog-487b7e73f1ec97f166172266ea2f53bf.svg";